import styled from "styled-components";
import { getImage } from "@nested/utils";
import { media, mediumHeading, mediumParagraph } from "@nested/brand";
import { ButtonLink as Link } from "@nested/component-library";

const H3 = styled.h3`
  ${mediumHeading}
  margin-top: 0px;
`;

const B = styled.span`
  ${mediumParagraph}
  font-weight: 500;
`;

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  ${media.desktop`
    padding-left: 0;
  `}
`;

const KeyFeature = styled.li`
  ${mediumParagraph}
  color: ${({ theme }) => theme.palette.hague80};
  margin: 10px 0;
  list-style-type: none;
  &:before {
    content: "";
    height: 5px;
    width: 5px;
    margin-top: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.terracotta100};
    position: absolute;
    left: 15px;
  }
`;

const KeyFeatureList = styled.ul`
  margin: 0 0 0 -10px;
  position: relative;

  ${media.tablet`
    margin-bottom: 20px;
  `};
  ${media.desktop`
    max-width: 490px;
  `};
`;

const ButtonLink = styled(Link)`
  font-weight: 400;
  margin-top: 30px;
  span {
    margin-right: 10px;
  }
  img {
    vertical-align: sub;
  }
`;

export const KeyFeatures = ({ keyFeatures, rightmoveLink }) => (
  <Wrapper>
    <H3>Key features</H3>
    <KeyFeatureList>
      {keyFeatures.map((keyFeature, index) => (
        <KeyFeature key={`${keyFeature + index}`}>{keyFeature}</KeyFeature>
      ))}
      <KeyFeature>
        All our properties are available to view virtually,{" "}
        <B>enquire below to book an online viewing</B>
      </KeyFeature>
    </KeyFeatureList>

    <ButtonLink to={rightmoveLink} type="standard">
      <span>View on</span>
      <img
        src={getImage("partners/rightmoveLogo.png")}
        style={{ width: "99px", height: "20px" }}
        alt="Rightmove logo"
      />
    </ButtonLink>
  </Wrapper>
);
